/* bb-judgeme-tweaks.js
   Sur la fiche produit : quand le preview-badge Judge.me a 0 avis,
   - on cache les étoiles
   - on remplace le libellé « 0 avis » par un CTA dans la langue de la page
   Le widget est rendu par Judge.me après chargement → observation via MutationObserver.
*/
(function () {
  var ROOT_SELECTOR = '.product-main, .product-info, [class*="judge_me_reviews_preview_badge"]';
  var locale = (document.documentElement.lang || 'fr').toLowerCase().split('-')[0];
  var REVIEW_LABELS = {
    fr: 'Laisser un avis',
    en: 'Write a review',
    de: 'Bewertung schreiben',
    es: 'Escribir una reseña',
    it: 'Scrivi una recensione',
    nl: 'Schrijf een beoordeling',
    pt: 'Escrever uma avaliação',
    ja: 'レビューを書く'
  };
  var TARGET_TEXT = REVIEW_LABELS[locale] || REVIEW_LABELS.en;

  function tweak(badge) {
    if (!badge || badge.getAttribute('data-bb-tweaked') === '1') return;
    var nb = badge.getAttribute('data-number-of-reviews');
    if (nb !== '0') return;

    var textEl = badge.querySelector('.jdgm-prev-badge__text');
    if (textEl) {
      textEl.textContent = TARGET_TEXT;
    }
    badge.setAttribute('data-bb-tweaked', '1');
  }

  function scan() {
    document.querySelectorAll('.jdgm-prev-badge[data-number-of-reviews="0"]').forEach(tweak);
    hideEmptyWrappers();
  }

  // Masquer les .product-info__block visuellement vides dans la buybox
  // (widget Judge.me display:none, ou widget vide, ou wrapper sans contenu utile)
  function hideEmptyWrappers() {
    var wraps = document.querySelectorAll('.dg-buybox-card .product-info__block, .product-main .product-info__block');
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      var shouldHide = false;
      var widget = w.querySelector('.jdgm-widget, .jdgm-preview-badge');
      if (widget) {
        try {
          if (window.getComputedStyle(widget).display === 'none') shouldHide = true;
        } catch (e) {}
        if (!shouldHide && widget.children.length === 0 && (widget.textContent || '').trim() === '') {
          shouldHide = true;
        }
      } else {
        // Pas de widget connu : si le wrapper est vide visuellement, le masquer
        if (w.children.length === 0 && (w.textContent || '').trim() === '') {
          shouldHide = true;
        }
      }
      if (shouldHide) {
        w.style.display = 'none';
      } else if (w.style.display === 'none') {
        w.style.display = '';
      }
    }
  }

  function init() {
    scan();
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('.jdgm-prev-badge')) tweak(n);
          if (n.querySelectorAll) {
            n.querySelectorAll('.jdgm-prev-badge[data-number-of-reviews="0"]').forEach(tweak);
          }
        }
        if (m.type === 'attributes' && m.target.matches && m.target.matches('.jdgm-prev-badge')) {
          tweak(m.target);
        }
      }
    });
    // Perf/INP : observer le conteneur produit plutôt que document.body entier
    // (le badge Judge.me est rendu dans .product-main / .product-info).
    var observeTarget = document.querySelector('.product-main')
      || document.querySelector('.product-info')
      || document.body;
    obs.observe(observeTarget, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-number-of-reviews']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
